import { Injectable } from '@angular/core';

import { ModalController } from '@ionic/angular';

import { ProductsService } from '@core/services/products/products.service';

import { ProductRequisitesComponent } from '@pages/product/_modals/product-requisites/product-requisites.component';

import { BaseProductCommand } from '@shared/commands/base-product.command';
import { IProductCommandContext } from '@shared/models/command';
import { ProductTypes } from '@shared/models/products.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';

@Injectable({ providedIn: 'root' })
export class RequisitesCommand extends BaseProductCommand {
  private readonly titleMap = {
    [ProductTypes.CARD]: 'Реквизиты счета',
    [ProductTypes.ACCOUNT]: 'Реквизиты',
    [ProductTypes.CREDIT]: 'Реквизиты',
    [ProductTypes.DEPOSIT]: 'Реквизиты',
    [ProductTypes.SAVE_ACCOUNT]: 'Реквизиты',
    [ProductTypes.METAL_ACCOUNT]: 'Реквизиты'
  } as const;

  readonly type = 'requisites';
  readonly icon = 'requisites-account';
  readonly productType: ProductTypes[] = [
    ProductTypes.ACCOUNT,
    ProductTypes.CARD,
    ProductTypes.CREDIT,
    ProductTypes.DEPOSIT,
    ProductTypes.SAVE_ACCOUNT,
    ProductTypes.METAL_ACCOUNT
  ];

  readonly isInfoAction = true;
  readonly settingsNames = undefined;
  readonly fallbackTitle = 'Реквизиты';

  get title(): string {
    return this.getContextualTitle(this.titleMap, this.fallbackTitle);
  }

  get order(): number {
    return this.getContextualOrder({
      [ProductTypes.ACCOUNT]: 20,        // Счет: Реквизиты (2-й в списке "прочее")
      [ProductTypes.SAVE_ACCOUNT]: 20,   // Накопительный счет: Реквизиты (2-й в списке "прочее")
      [ProductTypes.METAL_ACCOUNT]: 20,  // Металлический счет: Реквизиты (2-й в списке "прочее")
      [ProductTypes.CARD]: 20,           // Карты: Реквизиты счета (2-й в списке "прочее")
      [ProductTypes.CREDIT]: 40,         // Кредит: Реквизиты (4-й в списке "прочее")
      [ProductTypes.DEPOSIT]: 20         // Вклад: Реквизиты (2-й в списке "прочее")
    }, 999);
  }

  constructor(
    commandAvailabilityService: CommandAvailabilityService,
    private modalCtrl: ModalController,
    private productsService: ProductsService
  ) {
    super(commandAvailabilityService);
  }

  async execute(context: IProductCommandContext): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: ProductRequisitesComponent,
      handle: false,
      initialBreakpoint: 1,
      cssClass: 'modal-height-fix custom',
      componentProps: {
        data: this.productsService.getProductRequisites(context.data.id)
      }
    });

    await modal.present();
  }
}
